const langtrans={
      swbjjj:["尚未报价案件类型：","Type of case waiting for quotation:"],
      jxhhxh:["进行中案件","Cases in progress"],
      jqjqwc:["近期完成案件","Recent completed cases"],
      ddqzwm:["当前暂无数据哦～","Data is temporary not available"],
      ajttzz:["案件通知：江泰指挥中心邀请您参与以下案件报价，请您在30分钟内进行报价，逾期将视为放弃此案件的报价","Case Notice: Jiang Tai Command Center invites you to make a quotation for the following case. Please submit your quotation within 30 minutes to avoid being overdue."],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/views/commonPage/js/mainPase.vue.trans.js